export default __webpack_public_path__ + "static/media/terms.4e69cda8.pdf";